import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsDoneWorks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_DONE_WORKS,
		ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORKS,
		options
	)
}

function _getReportsDoneWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_DONE_WORKS,
		ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORK,
		options
	)
}

function _getReportsDoneWorkPreview(options = {}) {

	return _apiRequestWrap(
		ModulesMap.REPORTS_DONE_WORKS,
		ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORK_PREVIEW,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORKS]: _getReportsDoneWorks,

	[ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORK]: _getReportsDoneWork,

  [ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS].GET_REPORTS_DONE_WORK_PREVIEW]: _getReportsDoneWorkPreview,
}
